var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center text-base text-left mx-auto py-2.5 hover:bg-gray-200 hover:shadow-inner",on:{"click":_vm.handleGeoLocation}},[_c('img',{staticClass:"mr-2.5 ml-2 md:ml-0",attrs:{"src":require("@/assets/icons/gps.svg"),"alt":"Current Location"}}),_vm._v("\n\tCurrent Location\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }